// See: backend/docs/arvento-telemetry.md §20.1
// ŞU AN servis dışı çalışan araç sayısını periyodik çeker (canlı; araç durunca sıfırlanır — manuel onay yok).
// Kritik rozet bunu kullanır (yalnızca Telemetri + Uyarı Merkezi görünümlerinde).

import { useEffect, useRef, useState, useCallback } from "react";
import { useHttpClient } from "shared/hooks/http-hook";

const REFRESH_MS = 60 * 1000; // 60 sn

export const useTelemetryAlertCount = ({ enabled = true } = {}) => {
  const { sendRequest } = useHttpClient();
  const [count, setCount] = useState(0);
  const timerRef = useRef(null);
  const mountedRef = useRef(true);

  const fetchCount = useCallback(async () => {
    try {
      const data = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/telemetry/alerts/count`);
      if (!mountedRef.current) return;
      setCount(Number(data?.count) || 0);
    } catch (err) {
      // Rozet sessiz kalsın — hata UI'ı bozmaz.
    }
  }, [sendRequest]);

  useEffect(() => {
    mountedRef.current = true;
    if (!enabled) return undefined;
    fetchCount();
    timerRef.current = setInterval(fetchCount, REFRESH_MS);
    return () => {
      mountedRef.current = false;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [enabled, fetchCount]);

  return { count, refresh: fetchCount };
};

export default useTelemetryAlertCount;
